/*
 * 差し入れ選書ナビ (埋め込み版、Phase 2 改訂版)
 * 本番Dawnテーマの assets/concierge.js をベースに移植・改修したもの。
 *
 * 【今回の主な変更】
 * - 質問カードは1枚のみ（sections/jb-concierge.liquid の [data-cw-card]）。
 *   回答すると、そのカードの中身を次の質問にJSで差し替える（履歴・進捗チップは表示しない）。
 *   切り替え時にフェード＋わずかなスライドインのアニメーションを付ける（playEnterAnimation）。
 * - 旧Q5の読書頻度の質問（state.frequency、結果を絞り込みに使っていた）は廃止済み。
 *   今回追加した「普段、本を読むことは多いですか？」(state.readingHabit)は別物で、
 *   任意回答・スキップ可。商品の絞り込み（除外）には使わず、おすすめ順の小さな調整にだけ使う（下の説明参照）。
 * - 差し入れ用・自分用のどちらでも使えるよう、質問文は用途を限定しない表現にしている
 *   （「どんな本をお探しですか？」「読む方の年代は？」）。「差し入れ用／自分用」を選ばせる
 *   質問は追加していない。
 * - 質問の順番: 気持ち（どんな本を届けたいか）→ ジャンル → 年齢層 → 読書量(任意) → 予算 → 状態(新品/古本)。
 *   状態の質問が最後になったため、完了処理（GA4のcw_quiz_complete送信・結果表示）はそこで行う。
 * - 絵文字は使わず、質問内容に合わせた線画（アウトライン）SVGアイコンを都度差し込む（ICONS）。
 * - 選択肢の「選択済み」表現は黒ベタへの反転ではなく、濃い細枠＋淡い背景（cw-opt-btn.is-picked）。
 *
 * 商品データは templates/collection.cw-data.liquid が返すJSON（全ページ。下の説明参照）を使用し、
 * Storefront APIは使用しない。カート追加は標準Ajax Cart API (/cart/add.js)。
 * GA4計測・Googleスプレッドシートへのログ記録・sessionStorageでの状態復元は
 * 本番Dawnの仕組みをそのまま維持している。
 *
 * 表示は「閉じたバナー→クリックで展開」方式（ポップアップ・別ページ遷移ではなく、
 * このセクションの位置のままオーバーレイ(cw-scrim)で周囲を暗くして拡大表示する）。
 *
 * 【カートに入れる（1冊ずつすぐ追加）】
 * - 各カード・モーダルの「カートに入れる」は、押すとその1冊を /cart/add.js ですぐ追加する（addBook）。
 *   選択だけの状態・まとめて追加は廃止した（役割が重なるため）。
 * - 追加中は同じ本のボタンを押せない（inFlight）。追加済みの本は「カートに追加済み」にして再追加できない（addedIds）。
 *   失敗したら成功表示を出さず、その本のボタンの下に理由を出し、「もう一度カートに入れる」で再試行できる。
 *   再試行の前にカートを確認し、本選びナビ経由ですでに入っている本は追加済みとして扱う（二重追加を防ぐ）。
 * - モーダルから追加に成功したらモーダルを閉じ、元の結果一覧の位置に戻る。
 * - 結果の下に「ほかの本を探す」「服も見る」「カートを確認する」を常に表示する。追加後に自動でカート・
 *   チェックアウトへは移動しない（カート画面でお届け方法を選んでからチェックアウトする既存の流れはそのまま）。
 *
 * 【結果から購入までの導線（旧）】
 * - 本は複数選べる。下のバーに選択中の冊数と「ほかの本も続けて選べます」を表示する。
 * - まとめてカートに追加した後は自動でカートへ移動せず、成功したときだけ「選んだ本をカートに追加しました」と、
 *   「カートで注文内容を確認する」（主）・「ほかの本も探す」（結果一覧へ戻る）・「服も一緒に探す」を表示する。
 * - 失敗したときは成功の案内を出さず、理由を表示して追加ボタンから再試行できる。再試行の前にカートを確認し、
 *   すでに入っている本（本選びナビ経由で追加したもの）は追加済みとして扱い、二重に追加しない。
 *   追加済みの本は「カートに追加済み」にして重複追加を防ぐ（addedIds）。追加後にほかの本を選ぶと、
 *   新しく選んだ本だけを追加できる。追加済みの情報は途中保存にも残し、服を見て戻っても状態を復元する。
 * - カートでは既存のお届け方法の選択（施設直接代行・窓口持参・自分用）を経てチェックアウトへ進む（変更なし）。
 *
 * 【結果カードとモーダル】
 * - カードの順番: 表紙 → 本固有の見出し（catchphrase。未登録なら出さない）→ 著者名・タイトル・価格 →
 *   説明文の短い導入（intro。Liquidで文の区切りまで取り出したもの）→ 回答に合う理由（控えめ）→
 *   「本の内容をもっと見る」（主な操作）→ 選択。
 * - モーダルでは表紙を大きく表示し、商品に2枚以上の画像があれば前後ボタン・サムネイルで切り替える。
 *   カード用の見出し（catchphrase）はモーダルには出さない（説明文内の見出し・改行はそのまま表示）。
 * - 「本の内容をもっと見る」は、結果画面の上に <dialog> で商品説明を表示する（openDetail）。説明の全文は
 *   開いたときに /products/<handle>.js から取得する（一覧用データには説明文を含めない）。
 *   モーダル内の選択ボタンはカードのチェックボックスと連動。閉じたらスクロール位置とフォーカスを戻す。
 * - 理由の文は、照合したテーマ一致・ジャンル一致だけから組み立てる（buildReasonText。推測はしない）。
 *
 * 【商品データの読み込み（250件上限の解消）】
 * - 商品データはページに埋め込まず、診断を開いたとき（expand）に ensureBooks で
 *   data-cw-books-src（/collections/<handle>?view=cw-data）の全ページを並行して読み込み、結合する。
 *   最後のページが250件ちょうどなら次のページも確認する（商品が増えても全件が候補になる）。
 * - 途中保存からの再開で結果を組み立て直すときと、「おすすめの本を見る」を押したときは、読み込み完了を待つ。
 *   読み込みに失敗した場合は、その旨を表示し、もう一度押すと再読み込みする。
 *
 * 【読書量の回答をおすすめ順に反映】
 * - 各商品の読みやすさ（easy / normal / heavy / unknown）を readabilityOf で判定する:
 *   1. 商品メタフィールド custom.readability（読みやすい／ふつう／じっくり）があればそれを優先
 *   2. ジャンルが「雑誌・漫画」なら、ページ数に関係なく easy
 *   3. 説明文のページ数（Liquidで抽出した pages）: 200以下 easy / 350以上 heavy / その間 normal
 *      （区切りは、実際の商品のページ数分布の下位・上位25%の境目 199 / 350.5 を丸めた値）
 *   4. どれも無ければ unknown（候補から除外しない）
 * - 読書量の回答 × 読みやすさ で最大10点を加点する（READING_BONUS）。既存の加点（テーマ40・ジャンル30・
 *   年代タグ15）より小さく、並び順の微調整にだけ効く。除外条件にはしない。
 *   「スキップ」（value:null、わからない相当）と未回答（undefined）では加点しない。
 *
 * 【数量質問の廃止（1冊を探す流れに統一）】
 * - 「何冊お探しですか？（1冊／3冊セット）」の質問、3冊セット用の選び方（scoreBooksDiverse）、
 *   ジャンル3つ選択、3冊セットの注記は削除した。推薦は従来の1冊モードと同じ scoreBooks のみ
 *   （結果は最大 MAX_RESULTS 冊。そこから複数選んでカートに追加できる）。
 * - 最初の質問は「誰が読む本ですか？」（差し入れに／自分で読む。state.purpose）。次が「どんな本を届けたいですか？」
 *   （自分で読むときは「どんな本を読みたいですか？」。回答候補と値は従来の Q1_OPTIONS のまま）。
 *   用途は見出しの出し分け・計測（cw_purpose）・カートのお届け方法の初期選択にだけ使い、スコアリングには使わない。
 * - GA4／スプレッドシートの cw_mode とカートの _冊数モード は、列・表示の互換のため
 *   従来の1冊モードと同じ値（SINGLE_MODE_LOG_LABEL）で送る。
 * - 途中保存の形式を v5 にした（数量質問があった v4 以前の保存は読み込まず、最初から始める）。
 * - トップの入口は、5冊の本の写真のカード（jb-feature-card）の「本選びナビをはじめる」ボタン
 *   （data-cw-expand）。押すと1問目から始まる。#concierge / #book-navi 付きのリンクで来た場合も1問目から。
 *
 * 【見せ方・操作感の改修（質問・回答値・推薦ロジック・商品データ・カート追加・記録は変更なし）】
 * - 上部に進行状況（Q番号／全問数・細いバー）と「戻る」ボタン（updateChrome / goBack）。
 *   戻ると、その質問以降の回答を未回答に戻してから、その質問を表示し直す。
 * - 選択肢は大きな選択カード（番号は表示しない）。選ぶと細枠＋淡い背景で選択状態を一瞬見せてから次へ進む
 *   （advanceAfterPick）。数字キー 1〜9 でも選べる（表示のない補助操作）。質問が変わると見出しへフォーカスを移す。
 * - 結果は、書影と文字が短く浮かび上がる演出（0.36秒・8px。順番に 60ms ずつ遅らせる）。
 *   prefers-reduced-motion: reduce の場合は、演出・スムーズスクロール・待ち時間を省く。
 */
(function () {
  'use strict';

  var ICONS = {
    // 探す (バナー用・虫眼鏡)
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>',
    // 本の束（用途の質問で使用）
    book: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>',
    // 気持ち（ハート）
    heart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-6.7-4.35-9.3-8.1C.9 9.9 2 6.2 5.4 5.2 7.7 4.5 9.9 5.6 12 8c2.1-2.4 4.3-3.5 6.6-2.8 3.4 1 4.5 4.7 2.7 7.7C18.7 16.65 12 21 12 21z"></path></svg>',
    // ジャンル（しおり/タグ）
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3.5A1.5 1.5 0 0 1 7.5 2h9A1.5 1.5 0 0 1 18 3.5V21l-6-3.6L6 21V3.5z"></path></svg>',
    // 年齢層（人物）
    user: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="3.3"></circle><path d="M5 20c0-3.6 3.1-6.4 7-6.4s7 2.8 7 6.4"></path></svg>',
    // 予算（コイン）
    coin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="M9.3 15c.4.9 1.4 1.5 2.5 1.5 1.7 0 3-1 3-2.4 0-1.1-.9-1.8-2.6-2.2-1.9-.4-2.7-1-2.7-2.1 0-1.2 1.1-2 2.4-2 1 0 1.9.5 2.3 1.3M12 7v10"></path></svg>',
    // 状態・新品/古本（きらめき）
    sparkle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.7 4.3L18 9l-4.3 1.7L12 15l-1.7-4.3L6 9l4.3-1.7L12 3z"></path><path d="M19 15.5l.6 1.5 1.5.6-1.5.6-.6 1.5-.6-1.5-1.5-.6 1.5-.6.6-1.5z"></path></svg>',
    // 読書量（開いた本）
    reading: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 6.2c-1.7-1.3-3.9-2-6.2-2-1.1 0-2.1.15-2.8.4V18c.7-.25 1.7-.4 2.8-.4 2.3 0 4.5.7 6.2 2 1.7-1.3 3.9-2 6.2-2 1.1 0 2.1.15 2.8.4V4.6c-.7-.25-1.7-.4-2.8-.4-2.3 0-4.5.7-6.2 2z"></path><path d="M12 6.2V20"></path></svg>'
  };

  // 数量質問の廃止後も、GA4/スプレッドシートの cw_mode・カートの _冊数モード は従来の1冊モードの値で送る
  var SINGLE_MODE_LOG_LABEL = '最適な1冊を探す';

  // 最初の質問：誰が読む本か（用途）。回答で、後の質問の見出しとカートのお届け方法の初期選択が変わる。
  // 推薦（スコアリング）には使わない。value は保存・計測・カート引き継ぎ用の内部値。
  // GA4/スプレッドシートの cw_purpose は logLabel（従来の文言）で送る。表示の label だけを変えている
  var PURPOSE_QUESTION = '誰が読む本ですか？';
  var Q0_PURPOSE_OPTIONS = [
    { value: 'gift', label: '差し入れに', logLabel: '差し入れ・贈り物に' },
    { value: 'self', label: '自分で読む' }
  ];
  // 用途ごとの見出し（未回答のときは gift と同じ）
  var QUESTION_TITLES = {
    theme: { gift: 'どんな本を届けたいですか？', self: 'どんな本を読みたいですか？' },
    ageGroup: { gift: '差し入れ相手の年代は？', self: 'あなたの年代は？' },
    readingHabit: { gift: '差し入れ相手は、普段どれくらい本を読みますか？', self: '普段どれくらい本を読みますか？' }
  };
  // 本選びナビからカートへ進んだとき、カートのお届け方法を初期選択するための受け渡し
  // （assets/jb-cart-ordertype.js が読み取り、1回使ったら消す。カートでの変更は自由）
  var CART_PREF_KEY = 'jb_cart_pref_card';

  var Q1_OPTIONS = [
    { value: '前を向くための本', label: '気持ちが前向きになる本', logLabel: '前を向くきっかけになる本' },
    { value: '物語の中へ', label: '夢中になれる物語', logLabel: '引き込まれる物語の本' },
    // 用途で表示文言だけ出し分ける（labelSelf があれば「自分で読む」のときに使う）。value・logLabel・スコアリングは共通
    { value: '自分の外を知る本', label: '外の世界を知る本', labelSelf: '世界が広がる本', logLabel: '塀の外の世界が知れる本' },
    // 旧「これからを考えるきっかけになる本」（logLabel: 自分の人生を見つめ直せる本）から差し替え。
    // value は同じ（商品の テーマ メタフィールド＝アウトロー・リアリズム＝コレクション theme-outlaw の条件と一致する本に +40）。
    // 計測は過去のログと区別できるよう、旧選択肢とは別の logLabel にしている
    { value: 'アウトロー・リアリズム', label: 'アウトローの生き様を描いた本', logLabel: 'アウトローの生き様を描いた本' }
  ];

  var Q2_OPTIONS = [
    '小説・文芸',
    '社会・ノンフィクション',
    '哲学・思想',
    'エッセイ',
    '音楽・アート',
    '語学・学習',
    '雑誌・漫画'
  ].map(function (g) {
    // 表示は「漫画・雑誌」。内部の値（商品のジャンルと照合する値）は「雑誌・漫画」のまま
    return { value: g, label: g === '雑誌・漫画' ? '漫画・雑誌' : g };
  });

  var Q3_OPTIONS = [
    { value: null, label: 'こだわらない' },
    { value: 1000, label: '1,000円まで', logLabel: '〜1,000円' },
    { value: 2000, label: '2,000円まで', logLabel: '〜2,000円' },
    { value: 3000, label: '3,000円まで', logLabel: '〜3,000円' }
  ];

  var Q4_OPTIONS = [
    { value: null, label: 'どちらでも', logLabel: '新品・古本どちらでも' },
    { value: '新品', label: '新品のみ' }
  ];

  var Q6_OPTIONS = [
    { value: '10〜20代', label: '10〜20代' },
    { value: '30〜40代', label: '30〜40代' },
    { value: '50〜60代', label: '50〜60代' },
    { value: '70代以上', label: '70代以上' }
  ];

  // 普段の読書量（任意回答）。商品の絞り込みには使わない。「スキップ」は他の質問の
  // 「こだわらない」等と同じく value:null（未回答と区別するため、答えたことは記録する）。
  var Q5_READING_OPTIONS = [
    { value: 'rare', label: 'あまり読まない' },
    { value: 'sometimes', label: 'ときどき読む' },
    { value: 'often', label: 'よく読む' },
    { value: null, label: 'スキップ', logLabel: '未回答' }
  ];

  // 年齢層は専用メタフィールドを持たないため、商品タグとの一致でスコアに加点するだけにする
  // （フィルタにはしない。該当タグが未設定でも結果が0件になることはない）
  var TAG_HINT_SCORE = 15;
  var AGE_GROUP_TAG_HINTS = {
    '50〜60代': ['シニア向け'],
    '70代以上': ['シニア向け']
  };

  // 読みやすさの初期判定（ページ数の区切り）
  var PAGES_EASY_MAX = 200;   // 200ページ以下 → 読みやすい
  var PAGES_HEAVY_MIN = 350;  // 350ページ以上 → じっくり
  var MANGA_GENRE = '雑誌・漫画';
  // 商品ごとの個別設定（custom.readability）の値 → 判定
  var READABILITY_OVERRIDE = { '読みやすい': 'easy', 'ふつう': 'normal', 'じっくり': 'heavy' };
  // 読書量の回答 × 読みやすさ の加点（最大10）。unknown はページ数が分からない本で、ふつうと同じ扱い
  var READING_BONUS = {
    rare:      { easy: 10, normal: 4, heavy: 0,  unknown: 4 },
    sometimes: { easy: 6,  normal: 8, heavy: 4,  unknown: 6 },
    often:     { easy: 2,  normal: 6, heavy: 10, unknown: 6 }
  };

  var MAX_RESULTS = 6;
  var GENRE_CAP_WHEN_TWO = 3;

  var GA4_MEASUREMENT_ID = 'G-PGDGB528WX';

  function pushConciergeEvent(eventName, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: eventName };
      for (var k in extra) {
        if (extra.hasOwnProperty(k)) payload[k] = extra[k];
      }
      window.dataLayer.push(payload);
    } catch (e) { }

    try {
      if (typeof window.gtag === 'function') {
        var gaParams = {};
        for (var k2 in extra) {
          if (extra.hasOwnProperty(k2)) gaParams[k2] = extra[k2];
        }
        gaParams.send_to = GA4_MEASUREMENT_ID;
        window.gtag('event', eventName, gaParams);
      }
    } catch (e2) { }
  }

  var SHEET_LOG_URL = 'https://script.google.com/macros/s/AKfycbxKdXv2Quii52e6FYLus67XOwODi_JpkCRuVy1OJKnv32IrsjU-7CTFp9QDs6iqAO50/exec';

  function logToSheet(eventName, extra) {
    try {
      var payload = { event: eventName };
      for (var k in extra) {
        if (extra.hasOwnProperty(k)) payload[k] = extra[k];
      }
      fetch(SHEET_LOG_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      });
    } catch (e3) { }
  }

  function prefersReducedMotion() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  // 選択後、選択状態のカードを一瞬見せてから次へ進むまでの時間
  function pickDelay() { return prefersReducedMotion() ? 0 : 200; }

  // 選択カードの中身（文言・任意の注記・矢印）。番号は表示しない（数字キーでの選択は引き続き可能）
  function optInner(label, index, noteHtml) {
    return '<span class="cw-opt-label">' + label + (noteHtml || '') + '</span>' +
      '<span class="cw-opt-arrow" aria-hidden="true"></span>';
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var STORAGE_KEY = 'cw_state_v1';

  function readSavedConciergeState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      return (data && typeof data === 'object') ? data : null;
    } catch (e) {
      return null;
    }
  }

  function initWidget(root) {
    var state = {
      purpose: null,
      theme: null,
      genres: [],
      ageGroup: undefined,
      readingHabit: undefined,
      budget: undefined,
      condition: undefined,
      completed: false
    };
    var books = [];
    var booksPromise = null;
    var addedIds = []; // この結果からカートに追加済みのバリエーションID（重複追加を防ぐ）
    var failedIds = {};  // 追加に失敗した本（再試行の前にカートの中身を確認する）
    var inFlight = {};   // 追加中の本（連打による重複追加を防ぐ）
    var cartCount = 0;
    var currentStepIndex = 0;

    // 質問の並び。用途（誰が読む本か）→ 気持ち（どんな本を届けたいか）→ ジャンル → 年齢層 → 読書量(任意) → 予算 → 状態(新品/古本)。
    // 状態が最後の質問なので、そのrenderの中で完了処理（GA4送信・結果表示）まで行う。
    var STEPS = [
      { key: 'purpose', render: renderPurposeStep },
      { key: 'theme', render: renderThemeStep },
      { key: 'genres', render: renderGenreStep },
      { key: 'ageGroup', render: renderAgeGroupStep },
      { key: 'readingHabit', render: renderReadingHabitStep },
      { key: 'budget', render: renderBudgetStep },
      { key: 'condition', render: renderConditionStep }
    ];

    // 全商品を読み込む（1回だけ。失敗したら次回呼び出しで再試行できるよう promise を捨てる）
    var BOOKS_PAGE_SIZE = 250;
    function ensureBooks() {
      if (booksPromise) return booksPromise;
      var srcEl = $('[data-cw-books-src]', root);
      var src = srcEl ? srcEl.getAttribute('data-cw-books-src') : '';
      var pages = srcEl ? Math.max(1, parseInt(srcEl.getAttribute('data-cw-books-pages'), 10) || 1) : 0;
      if (!src) {
        books = [];
        booksPromise = Promise.resolve(books);
        return booksPromise;
      }
      function fetchPage(n) {
        var url = src + (src.indexOf('?') >= 0 ? '&' : '?') + 'page=' + n;
        // Accept: application/json を付けると Shopify が標準のコレクションJSONを返すため、付けない（HTMLとして受け取りJSONとして読む）
        return fetch(url, { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          })
          .then(function (text) {
            var data = JSON.parse(text);
            if (!Array.isArray(data)) throw new Error('unexpected book data format');
            return data;
          });
      }
      // 最後のページが満杯なら、さらに次のページを確認する（商品数の表示と実際がずれた場合の保険）
      function fetchRest(n, acc) {
        return fetchPage(n).then(function (list) {
          acc = acc.concat(list);
          return list.length >= BOOKS_PAGE_SIZE ? fetchRest(n + 1, acc) : acc;
        });
      }
      var firstPages = [];
      for (var n = 1; n <= pages; n++) firstPages.push(fetchPage(n));
      booksPromise = Promise.all(firstPages)
        .then(function (lists) {
          var all = [].concat.apply([], lists);
          var last = lists[lists.length - 1] || [];
          return last.length >= BOOKS_PAGE_SIZE ? fetchRest(pages + 1, all) : all;
        })
        .then(function (all) {
          var seen = {};
          books = all.filter(function (b) {
            if (!b || !b.id || seen[b.id]) return false;
            seen[b.id] = true;
            return true;
          });
          return books;
        })
        .catch(function (e) {
          console.error('concierge: failed to load book data', e);
          booksPromise = null;
          throw e;
        });
      return booksPromise;
    }

    function saveState() {
      try {
        var resultsEl = $('.cw-results', root);
        var cartBar = $('.cw-cart-bar', root);

        var data = {
          v: 6,
          purpose: state.purpose,
          theme: state.theme,
          genres: state.genres,
          ageGroup: state.ageGroup,
          readingHabit: state.readingHabit,
          budget: state.budget,
          condition: state.condition,
          completed: state.completed,
          hasResults: !!(resultsEl && resultsEl.style.display === 'block'),
          results: $all('.cw-book-card', root).map(function (card) {
            return {
              id: card.getAttribute('data-book-id'),
              themeMatched: card.getAttribute('data-theme-matched') === '1',
              matchedGenre: card.getAttribute('data-matched-genre') || null
            };
          }),
          addedIds: addedIds.slice(),
          cartDone: addedIds.length > 0,
          cartCount: cartCount
        };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch (e) { }
    }

    // 保存済みの回答から、まだ答えていない最初の質問のインデックスを求める
    function computeResumeIndex() {
      if (state.purpose == null) return 0;
      if (state.theme == null) return 1;
      if (!state.genres.length) return 2;
      if (state.ageGroup === undefined) return 3;
      if (state.readingHabit === undefined) return 4;
      if (state.budget === undefined) return 5;
      if (state.condition === undefined) return 6;
      return STEPS.length - 1;
    }

    function restoreState() {
      var saved = readSavedConciergeState();
      if (!saved) return false;
      // 質問の並びが違う以前の保存（数量質問があった v4 以前、用途の質問がなかった v5）は読み込まない
      if (saved.v !== 6) return false;

      var hasAnyAnswer = saved.purpose != null || saved.theme != null ||
        (saved.genres && saved.genres.length) || saved.ageGroup !== undefined ||
        saved.readingHabit !== undefined || saved.budget !== undefined || saved.condition !== undefined;
      if (!hasAnyAnswer) return false;

      state.purpose = saved.purpose != null ? saved.purpose : null;
      state.theme = saved.theme != null ? saved.theme : null;
      state.genres = saved.genres ? saved.genres.slice() : [];
      state.ageGroup = saved.ageGroup;
      state.readingHabit = saved.readingHabit;
      state.budget = saved.budget;
      state.condition = saved.condition;
      state.completed = !!saved.completed;

      currentStepIndex = computeResumeIndex();
      renderCurrentStep(false);
      updateChrome();

      if (state.completed) {
        hideCard();
        if (!(saved.hasResults && saved.results && saved.results.length)) {
          showResultsDirectly();
          return true;
        }
        // 結果の本は、商品データの読み込み後に組み立て直す
        ensureBooks().then(function () { restoreResults(saved); }).catch(function () { showReveal(); });
      }

      return true;
    }

    function restoreResults(saved) {
        var items = [];
        if (saved.hasResults && saved.results && saved.results.length) {
          items = saved.results.map(function (r) {
            var book = books.filter(function (b) { return String(b.id) === String(r.id); })[0];
            if (!book) return null;
            return { book: book, themeMatched: !!r.themeMatched, matchedGenre: r.matchedGenre || null };
          }).filter(function (x) { return x; });
        }

        if (items.length) {
          renderResults(items);
          // 追加済みの本を復元（以前の保存には addedIds が無いので、まとめて追加が完了していた選択を追加済みとみなす）
          var restoredAdded = saved.addedIds || (saved.cartDone ? saved.selectedIds : null) || [];
          restoredAdded.forEach(function (id) { markAdded(String(id)); });
          updateCartBar();
        } else {
          showReveal();
        }
    }

    // 質問カードの中身を差し替え、短いフェード＋スライドで見せる（戻るときは逆方向から）
    function playEnterAnimation(card, back) {
      var cls = back ? 'cw-card--enter-back' : 'cw-card--enter';
      card.classList.add(cls);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          card.classList.remove(cls);
        });
      });
    }

    // 進行状況（Q番号／全問数・バー）、「戻る」ボタン、案内文の表示を現在の状態に合わせる
    function updateChrome() {
      var quizBody = $('[data-cw-quiz-body]', root);
      var total = STEPS.length;
      var resultsShown = !!($('.cw-results', root) && $('.cw-results', root).style.display === 'block');
      var revealEl = $('.cw-reveal', root);
      var revealShown = !!(revealEl && revealEl.style.display !== 'none');
      var done = state.completed;
      var current = done ? total : currentStepIndex + 1;
      var answered = done ? total : currentStepIndex;

      var text = $('[data-cw-progress-text]', root);
      if (text) {
        text.innerHTML = done
          ? '<span class="cw-progress-num">' + pad2(total) + '</span><span class="cw-progress-sep">/</span>' + pad2(total) + '<span class="cw-progress-label">回答が揃いました</span>'
          : '<span class="cw-progress-num">Q' + pad2(current) + '</span><span class="cw-progress-sep">/</span>' + pad2(total);
      }
      var bar = $('[data-cw-progress]', root);
      if (bar) {
        bar.setAttribute('aria-valuemax', String(total));
        bar.setAttribute('aria-valuenow', String(answered));
        bar.setAttribute('aria-valuetext', done ? '全' + total + '問に回答済み' : total + '問中' + current + '問目');
      }
      var fill = $('[data-cw-progress-fill]', root);
      if (fill) fill.style.transform = 'scaleX(' + (answered / total) + ')';

      // 戻る: 2問目以降と、結果を見る前のワンクッション画面で表示（結果表示中は「最初に戻る」を使う）
      var back = $('[data-cw-back]', root);
      if (back) back.hidden = !((!done && currentStepIndex > 0) || (done && revealShown && !resultsShown));

      if (quizBody) {
        quizBody.classList.toggle('is-started', currentStepIndex > 0 || done);
        quizBody.classList.toggle('is-results', resultsShown);
      }
    }

    function pad2(n) { return (n < 10 ? '0' : '') + n; }

    // 質問が変わったら見出しへフォーカスを移す（キーボード・読み上げで次の質問が分かるように）
    function focusQuestion(card) {
      var title = $('.cw-q-title', card);
      if (!title) return;
      title.setAttribute('tabindex', '-1');
      try { title.focus({ preventScroll: true }); } catch (e) { title.focus(); }
    }

    // 質問カードの上端が画面外（上）に出ていたら、ナビの先頭まで戻す
    function keepQuestionInView() {
      var quizBody = $('[data-cw-quiz-body]', root);
      if (!quizBody) return;
      var top = quizBody.getBoundingClientRect().top;
      if (top < 0) quizBody.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    }

    // 選んだカードを選択状態（細枠＋淡い背景）にして一瞬見せ、他のカードを押せないようにしてから次へ進む
    function advanceAfterPick(card, btn, next) {
      if (card.getAttribute('data-busy') === '1') return;
      card.setAttribute('data-busy', '1');
      if (btn) btn.classList.add('is-picked');
      setTimeout(next, pickDelay());
    }

    function hideCard() {
      var card = $('[data-cw-card]', root);
      if (card) card.style.display = 'none';
    }

    function renderCurrentStep(animate, back) {
      var card = $('[data-cw-card]', root);
      if (!card) return;
      card.style.display = '';
      card.removeAttribute('data-busy');
      STEPS[currentStepIndex].render(card);
      var q = document.createElement('div');
      q.className = 'cw-q-num';
      q.setAttribute('aria-hidden', 'true');
      q.textContent = 'Q' + pad2(currentStepIndex + 1);
      card.insertBefore(q, card.firstChild);
      updateChrome();
      if (animate !== false) {
        playEnterAnimation(card, back);
        keepQuestionInView();
        focusQuestion(card);
      }
    }

    function goNext() {
      saveState();
      currentStepIndex += 1;
      if (currentStepIndex >= STEPS.length) return;
      renderCurrentStep(true);
    }

    // ひとつ前の質問へ戻る。戻り先の質問と、それ以降の回答を未回答の状態に戻す
    // （保存・再開処理 computeResumeIndex と整合させるため）。推薦ロジックには関与しない。
    function clearAnswersFrom(index) {
      for (var i = index; i < STEPS.length; i++) {
        var key = STEPS[i].key;
        if (key === 'theme' || key === 'purpose') state[key] = null;
        else if (key === 'genres') state.genres = [];
        else state[key] = undefined;
      }
      state.completed = false;
    }

    function goBack() {
      var resultsEl = $('.cw-results', root);
      if (resultsEl && resultsEl.style.display === 'block') return;
      var reveal = $('.cw-reveal', root);
      var fromReveal = state.completed && reveal && reveal.style.display !== 'none';
      if (fromReveal) {
        reveal.style.display = 'none';
        currentStepIndex = STEPS.length - 1;
      } else {
        if (currentStepIndex <= 0) return;
        currentStepIndex -= 1;
      }
      clearAnswersFrom(currentStepIndex);
      saveState();
      renderCurrentStep(true, true);
    }

    function initBackButton() {
      var back = $('[data-cw-back]', root);
      if (back) back.addEventListener('click', goBack);
    }

    // 数字キー 1〜9 で、表示中の選択カードを選ぶ。ナビが開いている間だけ有効で、
    // ナビの外の入力欄・リンク等にフォーカスがあるときは何もしない（ページ内のほかの操作を妨げない）
    function initKeyboard() {
      var quizBody = $('[data-cw-quiz-body]', root);
      if (!quizBody) return;
      document.addEventListener('keydown', function (e) {
        if (quizBody.hidden) return;
        var m = getModal();
        if (m && m.open) return;
        if (e.altKey || e.ctrlKey || e.metaKey) return;
        var t = e.target;
        var tag = t && t.tagName;
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (t && t.isContentEditable)) return;
        if (t && t !== document.body && t !== document.documentElement && !quizBody.contains(t)) return;
        if (!/^[1-9]$/.test(e.key)) return;
        var card = $('[data-cw-card]', root);
        if (!card || card.style.display === 'none') return;
        var btn = $all('.cw-opt-btn', card)[Number(e.key) - 1];
        if (!btn) return;
        e.preventDefault();
        btn.focus();
        btn.click();
      });
    }

    // 1つ選ぶと次へ進む質問用。選んだカードを一瞬反転させてから onPick を呼ぶ
    function renderOptionButtons(container, options, onPick) {
      var card = container.closest('[data-cw-card]');
      options.forEach(function (opt, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cw-opt-btn';
        btn.innerHTML = optInner(escapeHtml(opt.label), i);
        btn.addEventListener('click', function () {
          advanceAfterPick(card, btn, function () { onPick(opt, btn); });
        });
        container.appendChild(btn);
      });
    }

    function iconEl(name) {
      return '<div class="cw-q-icon" aria-hidden="true">' + ICONS[name] + '</div>';
    }

    // 用途に応じた見出し（未回答なら差し入れ・贈り物向け）
    function titleFor(key) {
      var t = QUESTION_TITLES[key];
      return state.purpose === 'self' ? t.self : t.gift;
    }

    // Q1: 誰が読む本か（用途）
    function renderPurposeStep(card) {
      card.innerHTML =
        iconEl('book') +
        '<div class="cw-q-title">' + PURPOSE_QUESTION + '</div>' +
        '<div class="cw-opt-grid cw-single-col" data-cw-options></div>';
      renderOptionButtons($('[data-cw-options]', card), Q0_PURPOSE_OPTIONS, function (opt) {
        state.purpose = opt.value;
        goNext();
      });
    }

    // Q2: どんな本を届けたいか／読みたいか（用途で見出しを出し分け）
    function renderThemeStep(card) {
      card.innerHTML =
        iconEl('heart') +
        '<div class="cw-q-title">' + titleFor('theme') + '</div>' +
        '<div class="cw-opt-grid cw-single-col" data-cw-options></div>';
      var themeOptions = Q1_OPTIONS.map(function (o) { return { value: o.value, label: themeOptionLabel(o) }; });
      renderOptionButtons($('[data-cw-options]', card), themeOptions, function (opt) {
        state.theme = opt.value;
        goNext();
      });
    }

    // Q2: ジャンル（ひとつ選んだら自動的に次の質問へ）
    function renderGenreStep(card) {
      var max = 1;
      card.innerHTML =
        iconEl('tag') +
        '<div class="cw-q-title">どのジャンルを探しますか？</div>' +
        '<div class="cw-note">気になるものをひとつ選んでください。</div>' +
        '<div class="cw-opt-grid" data-cw-options></div>';

      var grid = $('[data-cw-options]', card);

      Q2_OPTIONS.forEach(function (opt, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cw-opt-btn';
        btn.innerHTML = optInner(escapeHtml(opt.label), i);
        btn.setAttribute('aria-pressed', 'false');
        btn.dataset.cwGenre = opt.value;
        btn.addEventListener('click', function () {
          if (card.getAttribute('data-busy') === '1') return;
          var idx = state.genres.indexOf(opt.value);
          if (idx >= 0) {
            state.genres.splice(idx, 1);
            btn.classList.remove('is-picked');
            btn.setAttribute('aria-pressed', 'false');
          } else {
            if (state.genres.length >= max) {
              var removed = state.genres.shift();
              $all('.cw-opt-btn', grid).forEach(function (b) {
                if (b.dataset.cwGenre === removed) { b.classList.remove('is-picked'); b.setAttribute('aria-pressed', 'false'); }
              });
            }
            state.genres.push(opt.value);
            btn.classList.add('is-picked');
            btn.setAttribute('aria-pressed', 'true');
          }
          if (state.genres.length === max) {
            card.setAttribute('data-busy', '1');
            setTimeout(goNext, prefersReducedMotion() ? 0 : 350);
          }
        });
        grid.appendChild(btn);
      });
    }

    // Q3: 読む方の年代（差し入れ用・自分用のどちらでも使えるよう、用途を限定しない表現にしている）
    function renderAgeGroupStep(card) {
      card.innerHTML =
        iconEl('user') +
        '<div class="cw-q-title">' + titleFor('ageGroup') + '</div>' +
        '<div class="cw-opt-grid" data-cw-options></div>';
      renderOptionButtons($('[data-cw-options]', card), Q6_OPTIONS, function (opt) {
        state.ageGroup = opt.value;
        goNext();
      });
    }

    // Q4: 普段の読書量（任意回答・スキップ可）。候補の除外には使わず、computeScored で
    // 読みやすさとの組み合わせによる小さな加点（おすすめ順の調整）にだけ使う。スキップ時は調整しない。
    function renderReadingHabitStep(card) {
      card.innerHTML =
        iconEl('reading') +
        '<div class="cw-q-title">' + titleFor('readingHabit') + '</div>' +
        '<div class="cw-note">この質問は任意です。スキップできます。</div>' +
        '<div class="cw-opt-grid" data-cw-options></div>';
      renderOptionButtons($('[data-cw-options]', card), Q5_READING_OPTIONS, function (opt) {
        state.readingHabit = opt.value;
        goNext();
      });
    }

    // Q4: 予算
    function renderBudgetStep(card) {
      card.innerHTML =
        iconEl('coin') +
        '<div class="cw-q-title">1冊あたりの予算は？</div>' +
        '<div class="cw-opt-grid" data-cw-options></div>';
      renderOptionButtons($('[data-cw-options]', card), Q3_OPTIONS, function (opt) {
        state.budget = opt.value;
        goNext();
      });
    }

    // Q5: 本の状態（新品/古本）。並び順の最後の質問なので、ここで完了処理を行う
    function renderConditionStep(card) {
      card.innerHTML =
        iconEl('sparkle') +
        '<div class="cw-q-title">新品・古本の希望は？</div>' +
        '<div class="cw-opt-grid" data-cw-options></div>';
      renderOptionButtons($('[data-cw-options]', card), Q4_OPTIONS, function (opt) {
        state.condition = opt.value;
        state.completed = true;
        saveState();
        var summary = buildAnswerSummary();
        pushConciergeEvent('cw_quiz_complete', summary);
        logToSheet('cw_quiz_complete', summary);
        hideCard();
        showResultsDirectly();
      });
    }

    // 最後の回答のあと、「条件に合う本が見つかりました」の中間画面を挟まずに結果を表示する。
    // 商品データはナビを開いたときに読み込み始めているので、通常はすぐ表示できる。
    // 読み込めなかったときだけ、従来の中間画面（「結果を見る」で再試行できる）を出す。
    function showResultsDirectly() {
      var quizBody = $('[data-cw-quiz-body]', root);
      if (quizBody) quizBody.setAttribute('aria-busy', 'true');
      ensureBooks().then(function () {
        if (quizBody) quizBody.removeAttribute('aria-busy');
        runConcierge();
      }).catch(function () {
        if (quizBody) quizBody.removeAttribute('aria-busy');
        showReveal();
        var revealBtn = $('.cw-btn-reveal', root);
        if (revealBtn) { try { revealBtn.focus({ preventScroll: true }); } catch (e) { revealBtn.focus(); } }
      });
      updateChrome();
    }

    // 質問カードを隠した直後に表示するため、自動スクロールなしでも画面内に収まる
    function showReveal() {
      var reveal = $('.cw-reveal', root);
      if (!reveal) return;
      reveal.style.display = '';
      updateChrome();
    }

    function initRevealButton() {
      var btn = $('.cw-btn-reveal', root);
      if (!btn) return;
      var btnLabel = btn.textContent;
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var reveal = $('.cw-reveal', root);
        var status = $('[data-cw-load-status]', root);
        if (!status && reveal) {
          status = document.createElement('p');
          status.className = 'cw-load-status';
          status.setAttribute('data-cw-load-status', '');
          status.setAttribute('role', 'status');
          reveal.appendChild(status);
        }
        if (status) status.textContent = '';
        btn.disabled = true;
        btn.textContent = '本棚を読み込んでいます…';
        ensureBooks().then(function () {
          btn.disabled = false;
          btn.textContent = btnLabel;
          if (reveal) reveal.style.display = 'none';
          runConcierge();
        }).catch(function () {
          btn.disabled = false;
          btn.textContent = btnLabel;
          if (status) status.textContent = '本の情報を読み込めませんでした。通信環境をご確認のうえ、もう一度お試しください。';
        });
      });
    }

    function restartQuiz() {
      state.purpose = null;
      state.theme = null;
      state.genres = [];
      state.ageGroup = undefined;
      state.readingHabit = undefined;
      state.budget = undefined;
      state.condition = undefined;
      state.completed = false;
      currentStepIndex = 0;

      var results = $('.cw-results', root);
      if (results) results.style.display = 'none';
      var reveal = $('.cw-reveal', root);
      if (reveal) reveal.style.display = 'none';
      hideCartBar();

      renderCurrentStep(true);
      saveState();
    }

    function initRestartButton() {
      var restartBtn = $('[data-cw-restart]', root);
      if (restartBtn) restartBtn.addEventListener('click', restartQuiz);
    }

    function priceLabel(n) {
      return '¥' + Number(n).toLocaleString('ja-JP');
    }

    // ログ(GA4/スプレッドシート)・カート明細プロパティ用は従来の文言(logLabel)のまま。
    // 画面に表示する文言(label)だけを変更している。
    function getPurposeLabel(value) {
      var opt = Q0_PURPOSE_OPTIONS.filter(function (o) { return o.value === value; })[0];
      return opt ? (opt.logLabel || opt.label) : value;
    }

    // カートのお届け方法の初期選択（差し入れに → 差し入れ代行、自分で読む → 自分用）を受け渡す
    function saveCartPref() {
      try {
        if (state.purpose === 'gift') sessionStorage.setItem(CART_PREF_KEY, 'facility');
        else if (state.purpose === 'self') sessionStorage.setItem(CART_PREF_KEY, 'self');
      } catch (e) { }
    }

    function getThemeLabel(value) {
      var opt = Q1_OPTIONS.filter(function (o) { return o.value === value; })[0];
      return opt ? (opt.logLabel || opt.label) : value;
    }

    // 気持ちの選択肢の表示文言（用途が「自分で読む」で labelSelf があればそちら）
    function themeOptionLabel(opt) {
      return state.purpose === 'self' && opt.labelSelf ? opt.labelSelf : opt.label;
    }

    // 選書結果の理由テキスト（画面表示用）
    function getThemeDisplayLabel(value) {
      var opt = Q1_OPTIONS.filter(function (o) { return o.value === value; })[0];
      return opt ? themeOptionLabel(opt) : value;
    }

    function getGenreDisplayLabel(value) {
      var opt = Q2_OPTIONS.filter(function (o) { return o.value === value; })[0];
      return opt ? opt.label : value;
    }

    function getBudgetLabel(value) {
      var opt = Q3_OPTIONS.filter(function (o) { return o.value === value; })[0];
      return opt ? (opt.logLabel || opt.label) : 'こだわらない';
    }

    function getConditionLabel(value) {
      var opt = Q4_OPTIONS.filter(function (o) { return o.value === value; })[0];
      return opt ? (opt.logLabel || opt.label) : '新品・古本どちらでも';
    }

    function getAgeGroupLabel(value) {
      var opt = Q6_OPTIONS.filter(function (o) { return o.value === value; })[0];
      return opt ? (opt.logLabel || opt.label) : value;
    }

    // 読書量は任意回答。未到達(undefined)は「(未回答)」、スキップ選択(null)は「スキップ」と区別してログに残す
    function getReadingHabitLabel(value) {
      if (value === undefined) return '(未回答)';
      var opt = Q5_READING_OPTIONS.filter(function (o) { return o.value === value; })[0];
      return opt ? (opt.logLabel || opt.label) : value;
    }

    function buildAnswerSummary() {
      return {
        cw_mode: SINGLE_MODE_LOG_LABEL,
        cw_purpose: state.purpose ? getPurposeLabel(state.purpose) : null,
        cw_theme: state.theme ? getThemeLabel(state.theme) : null,
        cw_genres: state.genres.length ? state.genres.join(' / ') : null,
        cw_age_group: state.ageGroup ? getAgeGroupLabel(state.ageGroup) : null,
        cw_reading_habit: getReadingHabitLabel(state.readingHabit),
        cw_budget: getBudgetLabel(state.budget),
        cw_condition: getConditionLabel(state.condition)
      };
    }

    function buildConciergeProperties() {
      return {
        '_選書ナビ経由': 'はい',
        '_冊数モード': SINGLE_MODE_LOG_LABEL,
        '_気持ち': state.theme ? getThemeLabel(state.theme) : '(未回答)',
        '_ジャンル': state.genres.length ? state.genres.join(' / ') : '(未回答)',
        '_年齢層': state.ageGroup ? getAgeGroupLabel(state.ageGroup) : '(未回答)',
        '_読書量': getReadingHabitLabel(state.readingHabit),
        '_予算': getBudgetLabel(state.budget),
        '_状態': getConditionLabel(state.condition)
      };
    }

    // 回答に合う理由。実際に照合したテーマ一致・ジャンル一致だけから組み立てる（推測や選書したような表現はしない）
    function buildReasonText(item) {
      if (item.themeMatched && item.matchedGenre) {
        return '「' + getThemeDisplayLabel(state.theme) + '」という希望と、「' + getGenreDisplayLabel(item.matchedGenre) + '」のジャンルに合う一冊です。';
      }
      if (item.themeMatched) {
        return '「' + getThemeDisplayLabel(state.theme) + '」という希望に合う一冊です。';
      }
      if (item.matchedGenre) {
        return '「' + getGenreDisplayLabel(item.matchedGenre) + '」のジャンルに合う一冊です。';
      }
      return null;
    }

    // Liquid の strip_html で残った文字参照（&amp; など）を文字に戻す
    function decodeEntities(str) {
      var t = document.createElement('textarea');
      t.innerHTML = String(str == null ? '' : str);
      // 改行を取り除いた跡の連続した空白を詰め、句読点・閉じ括弧の直後の空白は取り除く
      return t.value.replace(/\s+/g, ' ').replace(/([、。」』）！？])\s+/g, '$1');
    }

    // 「著者名「タイトル」」形式の商品名を、著者名とタイトルに分ける（形式が違えば全体をタイトルとして扱う）
    function splitTitle(title) {
      var t = String(title || '');
      var i = t.indexOf('「');
      if (i > 0) return { author: t.slice(0, i).trim(), title: t.slice(i).trim() };
      return { author: '', title: t };
    }

    function matchesCondition(book, wanted) {
      if (!wanted) return true;
      if (book.condition === wanted) return true;
      if (Array.isArray(book.tags) && book.tags.indexOf(wanted) !== -1) return true;
      return false;
    }

    // 商品タグに、指定した候補キーワードのいずれかが含まれているか
    function hasAnyTag(book, hints) {
      if (!hints || !hints.length || !Array.isArray(book.tags)) return false;
      for (var i = 0; i < hints.length; i++) {
        if (book.tags.indexOf(hints[i]) !== -1) return true;
      }
      return false;
    }

    // 条件（在庫・状態・予算）で絞り込むだけの共通処理
    function filterPool() {
      var pool = books.filter(function (b) { return b.available !== false; });

      if (state.condition) {
        pool = pool.filter(function (b) { return matchesCondition(b, state.condition); });
      }
      if (state.budget) {
        pool = pool.filter(function (b) { return typeof b.price === 'number' && b.price <= state.budget; });
      }
      return pool;
    }

    // 商品の読みやすさ（個別設定 ＞ 雑誌・漫画 ＞ ページ数 ＞ 不明）
    function readabilityOf(b) {
      var ov = b.readability ? READABILITY_OVERRIDE[String(b.readability).trim()] : null;
      if (ov) return ov;
      if (b.genre === MANGA_GENRE) return 'easy';
      var pages = Number(b.pages) || 0;
      if (pages > 0) {
        if (pages <= PAGES_EASY_MAX) return 'easy';
        if (pages >= PAGES_HEAVY_MIN) return 'heavy';
        return 'normal';
      }
      return 'unknown';
    }

    // 読書量の回答に応じた加点。スキップ（null）・未回答（undefined）では 0（順位調整しない）
    function readingBonus(b) {
      var table = state.readingHabit ? READING_BONUS[state.readingHabit] : null;
      if (!table) return 0;
      return table[readabilityOf(b)] || 0;
    }

    // テーマ・ジャンル一致、年齢層タグ一致、読書量×読みやすさでスコアをつけ、降順に並べる共通処理
    function computeScored(pool) {
      var ageGroupHints = state.ageGroup ? AGE_GROUP_TAG_HINTS[state.ageGroup] : null;

      var scored = pool.map(function (b) {
        var score = 0;
        var themeMatched = false;
        var matchedGenre = null;
        if (state.theme && b.theme === state.theme) {
          score += 40;
          themeMatched = true;
        }
        if (state.genres.length && state.genres.indexOf(b.genre) !== -1) {
          score += 30;
          matchedGenre = b.genre;
        }
        if (ageGroupHints && hasAnyTag(b, ageGroupHints)) {
          score += TAG_HINT_SCORE;
        }
        score += readingBonus(b);
        score += Math.random() * 0.01;
        return { book: b, score: score, themeMatched: themeMatched, matchedGenre: matchedGenre };
      });

      scored.sort(function (a, b) { return b.score - a.score; });
      return scored;
    }

    function sortUsedLast(a, b) {
      var aUsed = matchesCondition(a.book, '古本') ? 1 : 0;
      var bUsed = matchesCondition(b.book, '古本') ? 1 : 0;
      return aUsed - bUsed;
    }

    // スコア上位を順に（従来の1冊モードの選び方。ジャンル2つ選択時のみ偏りをキャップ）
    function scoreBooks() {
      var scored = computeScored(filterPool());

      var twoGenres = state.genres.length === 2;
      var counts = {};
      var picked = [];
      for (var i = 0; i < scored.length; i++) {
        var item = scored[i];
        var g = item.book.genre;
        var capped = twoGenres && state.genres.indexOf(g) !== -1;
        if (capped) {
          counts[g] = counts[g] || 0;
          if (counts[g] >= GENRE_CAP_WHEN_TWO) continue;
        }
        picked.push(item);
        if (capped) counts[g] = (counts[g] || 0) + 1;
        if (picked.length >= MAX_RESULTS) break;
      }

      picked.sort(sortUsedLast);
      return picked;
    }

    function renderResults(items) {
      var results = $('.cw-results', root);
      var grid = $('.cw-book-grid', root);
      var empty = $('.cw-results-empty', root);
      grid.innerHTML = '';

      if (!items.length) {
        empty.style.display = '';
        grid.style.display = 'none';
        hideCartBar();
      } else {
        empty.style.display = 'none';
        grid.style.display = '';
        items.forEach(function (item, i) {
          var cardEl = renderCard(item);
          cardEl.style.setProperty('--cw-i', i);
          grid.appendChild(cardEl);
        });
        // 書影と文字が短く浮かび上がる演出（動きを減らす設定では付けない）
        if (!prefersReducedMotion()) {
          grid.classList.add('is-revealing');
          setTimeout(function () { grid.classList.remove('is-revealing'); }, 500 + items.length * 60);
        }
        initCartBarForResults();
      }
      results.style.display = 'block';
      updateChrome();
      results.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    }

    function renderCard(item) {
      var b = item.book;
      var card = document.createElement('div');
      card.className = 'cw-book-card';
      card.setAttribute('data-book-id', b.id);
      card.setAttribute('data-theme-matched', item.themeMatched ? '1' : '0');
      if (item.matchedGenre) card.setAttribute('data-matched-genre', item.matchedGenre);

      var isUsed = matchesCondition(b, '古本');
      var reasonText = buildReasonText(item);

      var names = splitTitle(b.title);
      card.innerHTML =
        '<div class="cw-shelf">' +
          '<a class="cw-cover-wrap" href="' + escapeAttr(b.url) + '">' +
            (b.image ? '<img src="' + escapeAttr(b.image) + '" alt="' + escapeAttr(b.title) + '" loading="eager" decoding="async">' : '') +
            (isUsed ? '<span class="cw-used-badge">USED</span>' : '') +
          '</a>' +
        '</div>' +
        (b.catchphrase ? '<p class="cw-catchphrase">' + escapeHtml(b.catchphrase) + '</p>' : '') +
        '<div class="cw-book-meta">' +
          '<a class="cw-title-link" href="' + escapeAttr(b.url) + '">' +
            (names.author ? '<span class="cw-author">' + escapeHtml(names.author) + '</span>' : '') +
            '<span class="cw-title">' + escapeHtml(names.title) + '</span>' +
          '</a>' +
          '<div class="cw-price">' + priceLabel(b.price) + '</div>' +
        '</div>' +
        (b.intro && decodeEntities(b.intro).trim() ? '<p class="cw-intro-text">' + escapeHtml(decodeEntities(b.intro).trim()) + '</p>' : '') +
        (reasonText ? '<p class="cw-reason">' + escapeHtml(reasonText) + '</p>' : '') +
        '<button type="button" class="cw-detail-link" data-cw-open-detail aria-haspopup="dialog">本の内容をもっと見る</button>' +
        '<button type="button" class="cw-add-btn" data-cw-add data-variant-id="' + escapeAttr(b.id) + '">カートに入れる</button>' +
        '<p class="cw-add-error" data-cw-add-error role="alert" hidden></p>';

      card.setAttribute('data-variant-id', b.id);
      var addBtn = $('[data-cw-add]', card);
      if (addBtn) addBtn.addEventListener('click', function () { addBook(b, card); });
      var detailBtn = $('[data-cw-open-detail]', card);
      if (detailBtn) detailBtn.addEventListener('click', function () { openDetail(b, card, detailBtn); });

      return card;
    }

    // ---- 「本の内容をもっと見る」モーダル ----
    var detailCache = {};
    var modalState = { card: null, trigger: null, scrollY: 0, book: null };

    function getModal() { return $('[data-cw-modal]', root); }

    // 商品説明（ストアで登録したHTML）から、スクリプト等の不要な要素と属性を取り除く
    function sanitizeDescription(html) {
      var doc = new DOMParser().parseFromString('<div>' + (html || '') + '</div>', 'text/html');
      var wrap = doc.body.firstChild;
      $all('script, style, iframe, object, embed, form, link, meta, input, button', wrap).forEach(function (el) { el.remove(); });
      $all('*', wrap).forEach(function (el) {
        Array.prototype.slice.call(el.attributes).forEach(function (a) {
          var n = a.name.toLowerCase();
          if (n.indexOf('on') === 0 || n === 'style' || n === 'class' || n === 'id') el.removeAttribute(a.name);
          if ((n === 'href' || n === 'src') && /^\s*javascript:/i.test(a.value)) el.removeAttribute(a.name);
        });
        if (el.tagName === 'A') { el.setAttribute('target', '_blank'); el.setAttribute('rel', 'noopener'); }
      });
      return wrap.innerHTML;
    }

    // 商品の説明文（全文HTML）と画像一覧を /products/<handle>.js から取得する
    function loadProductDetail(b) {
      if (detailCache[b.id]) return detailCache[b.id];
      var url = String(b.url || '').split('?')[0].split('#')[0] + '.js';
      detailCache[b.id] = fetch(url, { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
        .then(function (p) { return { description: (p && p.description) || '', images: (p && p.images) || [] }; })
        .catch(function (e) { delete detailCache[b.id]; throw e; });
      return detailCache[b.id];
    }

    // Shopify の画像URLに表示幅を付ける（//cdn... の相対プロトコルにも対応）
    function sizedImage(url, width) {
      if (!url) return '';
      var u = String(url);
      if (u.indexOf('//') === 0) u = 'https:' + u;
      return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
    }

    var gallery = { images: [], index: 0 };
    function showGalleryImage(i) {
      var modal = getModal();
      if (!modal || !gallery.images.length) return;
      gallery.index = (i + gallery.images.length) % gallery.images.length;
      var cover = $('[data-cw-modal-cover]', modal);
      if (cover) {
        cover.src = gallery.images[gallery.index];
        cover.hidden = false;
        cover.alt = gallery.images.length > 1 ? (modalState.book ? modalState.book.title : '') + '（画像 ' + (gallery.index + 1) + ' / ' + gallery.images.length + '）' : (modalState.book ? modalState.book.title : '');
      }
      $all('[data-cw-thumb]', modal).forEach(function (t, k) {
        t.classList.toggle('is-current', k === gallery.index);
        t.setAttribute('aria-current', k === gallery.index ? 'true' : 'false');
      });
    }
    function setGallery(urls) {
      var modal = getModal();
      if (!modal) return;
      gallery.images = urls.filter(Boolean);
      gallery.index = 0;
      var many = gallery.images.length > 1;
      var prev = $('[data-cw-modal-prev]', modal), next = $('[data-cw-modal-next]', modal), thumbs = $('[data-cw-modal-thumbs]', modal);
      if (prev) prev.hidden = !many;
      if (next) next.hidden = !many;
      if (thumbs) {
        thumbs.hidden = !many;
        thumbs.innerHTML = '';
        if (many) {
          gallery.images.forEach(function (src, k) {
            var t = document.createElement('button');
            t.type = 'button';
            t.className = 'cw-modal__thumb';
            t.setAttribute('data-cw-thumb', '');
            t.setAttribute('aria-label', '画像 ' + (k + 1) + ' を表示');
            t.innerHTML = '<img src="' + escapeAttr(src.replace(/width=\d+/, 'width=160')) + '" alt="" loading="lazy">';
            t.addEventListener('click', function () { showGalleryImage(k); });
            thumbs.appendChild(t);
          });
        }
      }
      showGalleryImage(0);
    }

    // モーダルの「カートに入れる」をカードの状態に合わせる
    function syncModalSelect() {
      var modal = getModal();
      if (!modal || !modal.open || !modalState.card) return;
      var btn = $('[data-cw-modal-select]', modal);
      var err = $('[data-cw-modal-error]', modal);
      if (!btn) return;
      var id = String(modalState.card.getAttribute('data-variant-id'));
      var added = addedIds.indexOf(id) !== -1;
      var busy = !!inFlight[id];
      btn.textContent = added ? 'カートに追加済み' : (busy ? '追加中…' : (failedIds[id] ? 'もう一度カートに入れる' : 'カートに入れる'));
      btn.disabled = added || busy;
      btn.classList.toggle('is-added', added);
      if (err) {
        var cardErr = $('[data-cw-add-error]', modalState.card);
        err.textContent = cardErr && !cardErr.hidden ? cardErr.textContent : '';
        err.hidden = !err.textContent;
      }
    }

    function openDetail(b, card, trigger) {
      var modal = getModal();
      if (!modal || typeof modal.showModal !== 'function') { window.location.href = b.url; return; }
      modalState = { card: card, trigger: trigger, scrollY: window.scrollY, book: b };
      var names = splitTitle(b.title);
      var set = function (sel, text) { var el = $(sel, modal); if (el) { el.textContent = text || ''; el.hidden = !text; } };
      set('[data-cw-modal-author]', names.author);
      set('[data-cw-modal-title]', names.title);
      set('[data-cw-modal-price]', priceLabel(b.price));
      // 取得前は一覧の表紙を表示し、取得後に全画像へ差し替える（1枚なら切り替え操作は出さない）
      setGallery(b.image ? [b.image] : []);
      var cover = $('[data-cw-modal-cover]', modal);
      if (cover && !b.image) { cover.removeAttribute('src'); cover.hidden = true; }
      var link = $('[data-cw-modal-link]', modal);
      if (link) link.href = b.url;
      var body = $('[data-cw-modal-body]', modal);
      if (body) { body.innerHTML = '<p class="cw-modal__loading">内容を読み込んでいます…</p>'; }
      document.documentElement.classList.add('cw-modal-open');
      modal.showModal();
      syncModalSelect();
      var inner = $('.cw-modal__inner', modal);
      if (inner) inner.scrollTop = 0;
      var closeBtn = $('[data-cw-modal-close]', modal);
      if (closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); } }
      loadProductDetail(b).then(function (d) {
        if (modalState.book !== b || !body) return;
        body.innerHTML = d.description ? sanitizeDescription(d.description) : '<p>この本の説明はまだ登録されていません。</p>';
        if (d.images.length) setGallery(d.images.map(function (u) { return sizedImage(u, 800); }));
      }).catch(function () {
        if (modalState.book !== b || !body) return;
        body.innerHTML = '<p>内容を読み込めませんでした。下の「商品ページで詳しく見る」からご覧ください。</p>';
      });
    }

    function closeDetail() {
      var modal = getModal();
      if (modal && modal.open) modal.close();
    }

    function initModal() {
      var modal = getModal();
      if (!modal) return;
      // dialog を body 直下へ移す（祖先の transform 等の影響を避ける。表示は top layer）
      document.body.appendChild(modal);
      var getModalFromBody = function () { return modal; };
      getModal = getModalFromBody;
      modal.addEventListener('close', function () {
        document.documentElement.classList.remove('cw-modal-open');
        var y = modalState.scrollY;
        var trigger = modalState.trigger;
        modalState.book = null;
        window.scrollTo(0, y);
        if (trigger) { try { trigger.focus({ preventScroll: true }); } catch (e) { trigger.focus(); } }
      });
      // 背景（dialog の外側）をクリックしたら閉じる
      modal.addEventListener('click', function (e) { if (e.target === modal) closeDetail(); });
      var closeBtn = $('[data-cw-modal-close]', modal);
      if (closeBtn) closeBtn.addEventListener('click', closeDetail);
      var prevBtn = $('[data-cw-modal-prev]', modal), nextBtn = $('[data-cw-modal-next]', modal);
      if (prevBtn) prevBtn.addEventListener('click', function () { showGalleryImage(gallery.index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { showGalleryImage(gallery.index + 1); });
      // スワイプでも画像を切り替える
      var stage = $('.cw-modal__stage', modal), sx = null;
      if (stage) {
        stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (sx === null || gallery.images.length < 2) return;
          var dx = e.changedTouches[0].clientX - sx; sx = null;
          if (Math.abs(dx) > 40) showGalleryImage(gallery.index + (dx < 0 ? 1 : -1));
        });
      }
      var selectBtn = $('[data-cw-modal-select]', modal);
      if (selectBtn) selectBtn.addEventListener('click', function () {
        if (!modalState.card || !modalState.book) return;
        addBook(modalState.book, modalState.card, { fromModal: true });
      });
    }

    function escapeHtml(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function escapeAttr(str) { return escapeHtml(str); }

    // カードを「カートに追加済み」にする
    function markAdded(id) {
      id = String(id);
      if (addedIds.indexOf(id) === -1) addedIds.push(id);
      delete failedIds[id];
      var card = $all('.cw-book-card', root).filter(function (c) { return c.getAttribute('data-variant-id') === id; })[0];
      if (!card) return;
      card.classList.add('is-added');
      var btn = $('[data-cw-add]', card);
      if (btn) { btn.disabled = true; btn.textContent = 'カートに追加済み'; btn.removeAttribute('aria-busy'); }
      var err = $('[data-cw-add-error]', card);
      if (err) { err.hidden = true; err.textContent = ''; }
    }

    function setCardBusy(card, busy) {
      var btn = $('[data-cw-add]', card);
      if (!btn) return;
      btn.disabled = busy;
      if (busy) { btn.setAttribute('aria-busy', 'true'); btn.textContent = '追加中…'; }
      else btn.removeAttribute('aria-busy');
    }

    function showCardError(card, message) {
      var btn = $('[data-cw-add]', card);
      if (btn) btn.textContent = 'もう一度カートに入れる';
      var err = $('[data-cw-add-error]', card);
      if (err) {
        err.textContent = message;
        err.hidden = false;
        // 下に固定したバーに隠れないよう、エラーが見える位置まで寄せる（モーダル表示中はモーダル内に出す）
        var m = getModal();
        if (!(m && m.open)) err.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'nearest' });
      }
    }

    // 再試行の前に、すでにカートに入っている（本選びナビ経由の）本かを確認する
    function isAlreadyInCart(id) {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : { items: [] }; })
        .then(function (cart) {
          return (cart.items || []).some(function (it) {
            return String(it.variant_id) === String(id) && it.properties && it.properties['_選書ナビ経由'] === 'はい';
          });
        })
        .catch(function () { return false; });
    }

    // 1冊をすぐカートに追加する
    function addBook(b, card, opts) {
      var id = String(b.id);
      if (addedIds.indexOf(id) !== -1 || inFlight[id]) return;
      inFlight[id] = true;
      setCardBusy(card, true);
      var err = $('[data-cw-add-error]', card);
      if (err) { err.hidden = true; err.textContent = ''; }
      syncModalSelect();
      var conciergeProps = buildConciergeProperties();

      (failedIds[id] ? isAlreadyInCart(id) : Promise.resolve(false)).then(function (already) {
        if (already) return { already: true };
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: conciergeProps }] })
        }).then(function (res) {
          if (!res.ok) {
            return res.json().catch(function () { return {}; }).then(function (data) {
              var e = new Error(data.description || data.message || 'add failed');
              e.userMessage = data.description || data.message || '';
              throw e;
            });
          }
          return res.json();
        });
      }).then(function () {
        delete inFlight[id];
        cartCount += 1;
        markAdded(id);
        updateCartBar();
        saveState();
        saveCartPref();
        var evtData = buildAnswerSummary();
        evtData.cw_book_count = 1;
        pushConciergeEvent('cw_add_to_cart', evtData);
        logToSheet('cw_add_to_cart', evtData);
        // ヘッダーのカート数・カートドロワーの中身を更新（ドロワーは開かない。自動でカートへも移動しない）
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
        var modal = getModal();
        if (opts && opts.fromModal && modal && modal.open) {
          modalState.trigger = $('[data-cw-add]', card) || modalState.trigger;
          closeDetail(); // 閉じると元の結果位置に戻る
        }
        announce(b.title + ' をカートに追加しました');
      }).catch(function (e) {
        delete inFlight[id];
        failedIds[id] = true;
        console.error('concierge: add to cart failed', e);
        setCardBusy(card, false);
        showCardError(card, 'カートに追加できませんでした。' + (e && e.userMessage ? '（' + e.userMessage + '）' : '通信環境をご確認のうえ、') + 'もう一度お試しください。');
        syncModalSelect();
      });
    }

    // 読み上げ用の通知（画面上の表示は結果下のバー）
    function announce(msg) {
      var el = $('[data-cw-cart-live]', root);
      if (el) { el.textContent = ''; setTimeout(function () { el.textContent = msg; }, 30); }
    }

    function initCartBarForResults() {
      var bar = $('.cw-cart-bar', root);
      if (!bar) return;
      addedIds = [];
      failedIds = {};
      bar.classList.add('is-shown');
      updateCartBar();
    }

    // 結果下のバー: 追加済みの冊数と、次の行き先（ほかの本を探す／服も見る／カートを確認する）
    function updateCartBar() {
      var bar = $('.cw-cart-bar', root);
      if (!bar) return;
      var n = addedIds.length;
      bar.classList.toggle('is-done', n > 0);
      var text = $('.cw-cart-bar-text', root);
      var sub = $('[data-cw-cart-sub]', root);
      if (text) text.textContent = n > 0 ? n + '冊をカートに追加しました' : '気になる本は「カートに入れる」で追加できます';
      if (sub) sub.textContent = n > 0 ? 'ほかの提案も続けて追加できます。カートは残ったままです。' : '続けて何冊でも追加できます';
      var note = $('.cw-cart-bar-note', bar);
      if (note) note.style.display = n > 0 ? '' : 'none';
    }

    function hideCartBar() {
      var bar = $('.cw-cart-bar', root);
      if (!bar) return;
      bar.classList.remove('is-shown');
      bar.classList.remove('is-done');
    }

    // 「ほかの本を探す」: 結果一覧の先頭へ戻る（追加済みの本はカートに残り、表示も残る）
    function initMoreBooksButton() {
      var more = $('[data-cw-more-books]', root);
      if (!more) return;
      more.addEventListener('click', function () {
        var head = $('.cw-results-head', root) || $('.cw-results', root);
        if (!head) return;
        head.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
        var h = $('h3', head) || head;
        h.setAttribute('tabindex', '-1');
        try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); }
      });
    }

    function runConcierge() {
      var items = scoreBooks();
      renderResults(items);
      saveState();
    }

    // バナー（閉じた状態） ⇄ 質問フロー（展開状態）の切り替え。
    // 別ページへの遷移や画面隅floatのポップアップにはせず、このセクションの位置のまま
    // 周囲にオーバーレイ（scrim）をかけて診断部分にフォーカスを集める。
    function getScrim() {
      // initClose() で document.body 直下へ移動済みのため、root配下ではなく全体から探す
      return $('[data-cw-scrim]');
    }

    function expand() {
      // 質問に答えている間に商品データを読み込んでおく
      ensureBooks().catch(function () {});
      var banner = $('[data-cw-expand]', root);
      var quizBody = $('[data-cw-quiz-body]', root);
      var scrim = getScrim();
      if (banner) banner.hidden = true;
      if (quizBody) quizBody.hidden = false;
      if (scrim) scrim.hidden = false;
    }

    function collapse() {
      var banner = $('[data-cw-expand]', root);
      var quizBody = $('[data-cw-quiz-body]', root);
      var scrim = getScrim();
      if (banner) banner.hidden = false;
      if (quizBody) quizBody.hidden = true;
      if (scrim) scrim.hidden = true;
    }

    function initBanner() {
      var banner = $('[data-cw-expand]', root);
      if (!banner) return;
      banner.addEventListener('click', function () {
        expand();
        pushConciergeEvent('cw_widget_open', {});
        // 開いたら、表示中の質問の見出しへフォーカスを移す（キーボード操作・読み上げ用）
        var card = $('[data-cw-card]', root);
        if (card && card.style.display !== 'none') focusQuestion(card);
      });
    }

    function initClose() {
      // 祖先の transform / isolation の影響を受けないよう scrim は body 直下へ移す
      var scrim = $('[data-cw-scrim]', root);
      if (scrim) document.body.appendChild(scrim);

      var closeBtn = $('[data-cw-close]', root);
      if (closeBtn) closeBtn.addEventListener('click', collapse);
      if (scrim) scrim.addEventListener('click', collapse);

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var m = getModal();
        if (m && m.open) return; // モーダルを閉じる Esc では、本選びナビ自体は閉じない
        var quizBody = $('[data-cw-quiz-body]', root);
        if (quizBody && !quizBody.hidden) collapse();
      });
    }

    // #concierge / #book-navi 付きのリンクで来た場合は、1問目から開く
    function openFromHashIfRequested() {
      if (!/^#(concierge|book-navi)$/.test(window.location.hash || '')) return;
      expand();
      pushConciergeEvent('cw_widget_open', {});
      renderCurrentStep(false);
      var quizBody = $('[data-cw-quiz-body]', root);
      if (quizBody) quizBody.scrollIntoView({ block: 'start' });
      var card = $('[data-cw-card]', root);
      if (card) focusQuestion(card);
    }

    // バナーの「全○問・選ぶだけで答えられます」の数字を、質問の定義（STEPS）から数えて合わせる。
    // テーマ設定（button_note）の文言はそのまま使い、「全○問」の数字だけを置き換える（質問を増減しても直し忘れない）
    function syncQuestionCount() {
      var note = $('.jb-fc__note', root);
      if (note && /全\s*\d+\s*問/.test(note.textContent)) {
        note.textContent = note.textContent.replace(/全\s*\d+\s*問/, '全' + STEPS.length + '問');
      }
    }

    syncQuestionCount();
    initModal();
    initBanner();
    initClose();
    initBackButton();
    initKeyboard();
    initRestartButton();
    initRevealButton();
    initMoreBooksButton();

    // 進行中のセッションがあれば、バナーを飛ばして展開済みの状態からそのまま再開する
    if (restoreState()) {
      expand();
    } else {
      renderCurrentStep(false);
      openFromHashIfRequested();
    }
  }

  function init() {
    $all('.concierge-widget').forEach(function (root) {
      initWidget(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // テーマエディタでセクションが保存・再読み込みされると、このファイル自体は
  // 再実行されずセクションのHTMLだけが差し替わるため、クリックしても質問カードが
  // 出てこない（文字だけの静的な表示に見える）ことがある。Shopifyのセクション
  // ライフサイクルイベントで、差し替えられたセクション内の .concierge-widget だけを
  // 再初期化する。ストア公開後の通常表示（テーマエディタ外）ではこのイベントは
  // 発火しないため、既存の動作には影響しない。
  document.addEventListener('shopify:section:load', function (event) {
    $all('.concierge-widget', event.target).forEach(function (root) {
      initWidget(root);
    });
  });
})();
